import React from 'react';
import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    ListItem,
    ListItemText,
    Divider,

} from '@mui/material';

const SettingConfirmationDialog = (props) => {
    // console.log("props.message", props);
    const onClick = (value) => {
        if (value === "cancel") {
            props.onCancelClick(false);
        }
        else if (value === "ok") {
            props.handleCnfClick();
        }
    }



    return (
        <div>
            <Dialog id="confirmationDialog"
                open={props.open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth={'xs'}
            >
                {props.title ?
                    <DialogTitle id="alert-dialog-title">
                        {props.title}
                    </DialogTitle> : null
                }
                <DialogContent>
                    <>
                        {props.message && props.message.length > 0 ? props.message.map((v, i) => {
                            return (
                                <>
                                    <ListItem key={i}>
                                        <ListItemText primary={v.tagName} />
                                    </ListItem>
                                    <Divider />
                                </>)
                        }) : null}
                    </>
                </DialogContent>
                <DialogActions sx={{display:'flex', justifyContent:'center', alignItems:'center'}} >
                    <Button variant="contained" onClick={() => onClick("cancel")} color="primary">
                        {props.CancelButtonText}
                    </Button>
                    {/* <Button onClick={() => onClick("ok")} color="secondary" autoFocus>
                        {props.OkButtonText}
                    </Button> */}
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default SettingConfirmationDialog;

SettingConfirmationDialog.defaultProps = {
    CancelButtonText: "Cancel",
    OkButtonText: "OK",
    title: '',
    message: ''
}